"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var types_1 = require("../../middleware/api/types");
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
var api_1 = require("../../utils/api");
var getSlotsByTimeRange_1 = __importDefault(require("./queries/getSlotsByTimeRange"));
var getSlotByStartTime_1 = __importDefault(require("./queries/getSlotByStartTime"));
var getSlotsByIds_1 = __importDefault(require("./queries/getSlotsByIds"));
var selectors_1 = require("./selectors");
var selectors_2 = require("../devices/selectors");
exports.fetchSlotsByTimeRange = function (from, to, fetchOptions) {
    if (fetchOptions === void 0) { fetchOptions = {}; }
    return api_1.createApiAction(constants_1.FETCH_SLOTS_BY_TIME_RANGE, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        method: types_1.HTTPMethod.GET,
        params: {
            query: getSlotsByTimeRange_1.default(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.needDetail, fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.needReverseEPG),
            variables: { from: from, to: to },
        },
        authenticated: true,
        fetchFunc: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.fetchFunc,
        graphQL: true,
        meta: { isOverride: fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.isOverride },
        etagSelector: selectors_1.slotsByChannelIdState,
    });
};
exports.fetchSlotByStartTime = function (_a) {
    var channelId = _a.channelId, slotStartTime = _a.slotStartTime, needReverseEPG = _a.needReverseEPG, isPPV = _a.isPPV;
    return function (dispatch, getState) {
        var deviceId = selectors_2.getSerialNumber(getState());
        return dispatch(api_1.createApiAction(constants_1.FETCH_SLOT_BY_START_TIME, {
            baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
            params: {
                query: getSlotByStartTime_1.default(needReverseEPG, isPPV),
                variables: { channelId: channelId, at: slotStartTime, deviceId: deviceId },
            },
            authenticated: true,
            graphQL: true,
        }));
    };
};
exports.clearSelectedSlot = function () { return toolkit_1.createAction(constants_1.CLEAR_SELECTED_SLOT)({}); };
exports.fetchScheduledSlotsByIds = function (ids) {
    return api_1.createApiAction(constants_1.FETCH_SLOTS_BY_IDS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getSlotsByIds_1.default,
            variables: { ids: ids },
        },
        authenticated: true,
        graphQL: true,
        method: types_1.HTTPMethod.GET,
        etagSelector: selectors_1.scheduledSlotsState,
    });
};
exports.clearScheduledSlots = function () { return toolkit_1.createAction(constants_1.CLEAR_SCHEDULED_SLOTS)({}); };
//# sourceMappingURL=actions.js.map